import { useTranslation } from "react-i18next";
import { mainSiteUrl } from "@/mocks/categories";

export default function Hero() {
  const { t } = useTranslation();

  return (
    <section id="top" className="relative overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=A_stylish_minimal_fashion_display_with_a_pair_of_white_sneakers_a_folded_blush_sweater_a_denim_jacket_and_a_canvas_tote_bag_arranged_diagonally_on_a_warm_terracotta_and_cream_backdrop_with_golden_hour_light_and_soft_long_shadows_high_detail_editorial_photography_inviting_premium_fresh_aesthetic&width=1600&height=900&seq=hero-fashion-flatlay&orientation=landscape&nocache=true"
          alt="USFans Spreadsheet fashion categories"
          className="h-full w-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-background-950/60 via-background-950/40 to-background-950/60"></div>
      </div>

      <div className="relative z-10 mx-auto flex min-h-[640px] w-full max-w-[900px] flex-col items-center justify-center px-4 py-28 text-center md:px-6">
        <span className="rounded-full border border-background-50/40 bg-background-50/10 px-4 py-1.5 text-xs font-semibold uppercase tracking-wider text-background-50 md:text-sm">
          {t("hero.eyebrow")}
        </span>

        <h1 className="mt-6 font-heading text-3xl font-bold leading-tight text-background-50 md:text-5xl">
          {t("hero.title")}
        </h1>

        <p className="mt-5 max-w-2xl text-base leading-relaxed text-background-100 md:text-lg">
          {t("hero.description")}
        </p>

        <div className="mt-8 flex w-full flex-col items-center justify-center gap-3 sm:flex-row">
          <a
            href={mainSiteUrl}
            target="_blank"
            rel="noopener nofollow"
            className="w-full rounded-full bg-primary-500 px-7 py-3 text-center text-base font-semibold text-background-50 transition-colors hover:bg-primary-600 sm:w-auto whitespace-nowrap"
          >
            {t("main.usfansSpreadsheet")}
          </a>
          <a
            href={mainSiteUrl}
            target="_blank"
            rel="noopener nofollow"
            className="w-full rounded-full border border-background-50/60 bg-background-50/10 px-7 py-3 text-center text-base font-semibold text-background-50 transition-colors hover:bg-background-50/20 sm:w-auto whitespace-nowrap"
          >
            {t("main.buyNow")}
          </a>
        </div>

        <p className="mt-8 text-xs font-medium text-background-200 md:text-sm">{t("hero.trust")}</p>

        <a
          href="#categories"
          className="mt-10 flex flex-col items-center gap-2 text-background-200 transition-colors hover:text-background-50"
        >
          <span className="text-xs font-medium">{t("categoriesSection.browseAll")}</span>
          <span className="flex h-6 w-6 items-center justify-center">
            <i className="ri-arrow-down-line text-lg"></i>
          </span>
        </a>
      </div>
    </section>
  );
}